import React from 'react';
import { QueryRenderer, graphql } from 'react-relay';
import { connect } from 'react-redux';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';
import fuzzy from 'fuzzy';

import environment from '../../relay/environment';
import Client from './Client';
import styles from './styles.scss';
import ClientListFilters from './ClientListFilters';

class RenderedClients extends React.Component {
  static propTypes = {
    clients: PropTypes.arrayOf(PropTypes.object).isRequired,
    activeClient: PropTypes.string,
  }

  static defaultProps = {
    activeClient: '',
  }

  componentDidMount() {
    this.scrollToClient();
  }

  componentDidUpdate() {
    this.scrollToClient();
  }

  scrollToClient = () => {
    const node = ReactDom.findDOMNode(this.refs.activeClient); // eslint-disable-line
    if (node) {
      node.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  }

  render() {
    const { clients, activeClient } = this.props;

    return (<div className={styles.listItems}>{clients.map((client) => {
      const { id: clientId } = client;
      const active = clientId === activeClient;
      const ref = active ? 'activeClient' : null;

      return (<Client
        key={clientId}
        client={client}
        active={active}
        ref={ref}
      />);
    })}</div>);
  }
}

@connect(state => ({
  windowHeight: state.Responsive.get('windowHeight'),
}))
class Renderer extends React.Component { // eslint-disable-line
  static propTypes = {
    activeClient: PropTypes.string,
    loadingEl: PropTypes.element.isRequired,
  }

  static defaultProps = {
    activeClient: '',
  }

  constructor(props) {
    super(props);

    this.state = {
      clientFilter: '',
    };
  }

  updateClientFilter = (e) => {
    const { target: { value: clientFilter } } = e;
    this.setState({ clientFilter });
  }

  render() {
    const { activeClient, loadingEl } = this.props;
    const { clientFilter } = this.state;
    const updateClientFilter = this.updateClientFilter;

    return (<QueryRenderer
      environment={environment}
      query={graphql`
        query ClientListRenderer_ClientList_Query {
          allTravelers {
            edges {
              node {
                id,
                fullName,
                displayName,
                isPrimaryTraveler,
                primaryTraveler {
                  fullName,
                  displayName
                }
              }
            }
          }
        }
      `}
      render={({ error, props }) => {
        if (error) {
          return <div>{error.message}</div>;
        } else if (props) {
          const { allTravelers: { edges: clients } } = props;

          let filteredClients = clients.map(({ node }) => node);
          if (clientFilter) {
            filteredClients = fuzzy.filter(
              clientFilter, clients.map(({ node }) => node), {
                extract: ({ displayName, fullName, isPrimaryTraveler, primaryTraveler }) => {
                  if (isPrimaryTraveler || primaryTraveler === null) {
                    return `${fullName} ${displayName}`;
                  }

                  return `${fullName} ${displayName} ${primaryTraveler.fullName} ${primaryTraveler.displayName}`;
                },
              }
            ).map(filteredClient => filteredClient.original);
          }

          return (<div>
            <ClientListFilters
              numClients={clients.length}
              numFiltered={filteredClients.length}
              updateFilter={updateClientFilter}
              filter={clientFilter}
            />
            <RenderedClients
              clients={filteredClients}
              activeClient={activeClient}
            />
          </div>);
        }

        return loadingEl;
      }}
    />);
  }
}

export default Renderer;



// WEBPACK FOOTER //
// /src/components/Clients/ClientListRenderer.js